import { useGetMicrogrid } from 'features/microgrid/hooks';
import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { useParams } from 'react-router-dom';
import { PROJECT_CACHE_KEY } from 'services/queryKeys';
import { Project } from 'types';

export function CreateReportBreadcrumb() {
  const { projectSlug = '', microgridId = '' } = useParams();
  const { data = [] as Project[] } = useAxiosQuery<Project>(
    PROJECT_CACHE_KEY(projectSlug),
    `/projects/my-projects/?external_identifier__eq=${projectSlug}`
  );
  const project = data?.[0] ?? {};

  const { microgrid } = useGetMicrogrid({
    projectId: project?.projectId,
    microgridId,
  });

  return microgrid?.name ?? microgridId;
}
